import { takeEvery } from "redux-saga/effects"
import { omit, capitalize } from "lodash"

const RX_CAPS = /(?!^)([A-Z])/g

function camelToWords(str) {
  const formatted = str.replace(RX_CAPS, " $1")
  return formatted.charAt(0).toUpperCase() + formatted.slice(1)
}

function screamingSnakeToWords(str) {
  return str.split("_")
    .map(capitalize)
    .join(" ")
}

function formatAction(type) {
  const parts = type.split("/")
  return `${camelToWords(parts[2])} - ${screamingSnakeToWords(parts[3])}`
}

export function callAnalyticsEvent(action) {
  let type, payload

  if (action.meta.trackType) {
    if (typeof action.meta.trackType === "function") {
      type = action.meta.trackType(action)
    } else {
      type = action.meta.trackType
    }
  } else {
    type = formatAction(action.type)
  }

  if (action.meta.trackPayload) {
    if (typeof action.meta.trackPayload === "function") {
      payload = action.meta.trackPayload(action)
    } else {
      payload = action.meta.trackPayload
    }
  } else {
    payload = omit(action, ["type", "meta"])
  }

  window.analytics.track(type, payload)
}

export default function* () {
  yield takeEvery(action => action.meta && action.meta.track, callAnalyticsEvent)
}
